<template>
  <v-app app>
    <v-main app>
      <v-app-bar dense dark>
        <v-btn icon @click="goBack">
          <v-icon large>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title>图片上传</v-toolbar-title>
      </v-app-bar>
      <v-container>
        <v-file-input
          @change="onInputImgChange"
          v-model="inputImg"
          :accept="acceptImgTypes"
          placeholder="请选择图片"
          prepend-icon="mdi-camera"
          label="图片上传"
        ></v-file-input>
        <v-switch v-model="isNotPrivate" class="ma-2" label="允许公开图片"></v-switch>

        <v-card v-if="inputImgDecode" class="mb-5 img-preview pt-2 pb-2 pl-2 pr-2">
          <v-img contain height="150px" :src="inputImgDecode"></v-img>
          <v-card-subtitle class="grey--text text-center">预览</v-card-subtitle>
        </v-card>

        <v-btn @click="onUploadBtn" rounded color="blue" dark block>上传</v-btn>
        <ul v-if="this.$route.params.type === 'nav'" class="pt-5 pb-5 text--secondary">
          <li>导航屏背景图推荐采用宽高比为3:1的图，推荐分辨率900*300。</li>
          <li>建议在图片下方1/3区域处绘制图案，上方2/3处留空</li>
        </ul>
        <ul v-if="this.$route.params.type === 'dbas'" class="pt-5 pb-5 text--secondary">
          <li>信息屏左侧图建议使用黑色背景或者透明背景</li>
          <li>动图会额外增加车机1%～10%的CPU占用，建议使用静态图，零CPU占用</li>
        </ul>
        <v-overlay :value="isLoading" class="text-center" opacity="0.8">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
          <br />
          <div class="mt-5 white--text text-subtitle-1">{{ imgUploadPercent }}%</div>
        </v-overlay>
        <v-dialog v-model="uploadAlertDialog">
          <v-card>
            <v-card-title class="headline grey lighten-2">确认上传？</v-card-title>

            <v-card-text class="pt-5">系统如果发现违规图片(如：政治、色情、暴力等相关)，将取消发布者所有付费软件激活，同时还会将其信息提交到司法机关处理</v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="onConfirmUpload">确认上传</v-btn>
              <v-spacer></v-spacer>
              <v-btn text @click="uploadAlertDialog = false">取消上传</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="successUploadDialog">
          <v-card>
            <v-card-title class="headline grey lighten-2">上传成功</v-card-title>

            <v-img class="mt-5 mb-5" :src="uploadedImgUrl" contain height="150px" />

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="onContinueUpload">继续上传</v-btn>
              <v-spacer></v-spacer>
              <v-btn text @click="onGoToMy">回到我的</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-snackbar v-model="showErrorMsg" :timeout="8000">
          {{ errorMsg }}
          <template v-slot:action="{ attrs }">
            <v-btn color="red" text v-bind="attrs" @click="showErrorMsg = false">关闭</v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { ossSts, doneUploadImg } from '../util/api'
import { asssetNameToId } from '../util/tool'
export default {
  name: 'DbAsUploadImg',
  data() {
    let acceptImgTypes = 'image/png, image/jpeg, image/jpg, image/bmp'
    if (this.$route.params.type === 'dbas') {
      // 仅导航屏左侧图支持gif
      acceptImgTypes += ', image/gif'
    }
    return {
      // 图片上传进度
      imgUploadPercent: 0,
      // 上传内容警告弹窗
      uploadAlertDialog: false,
      // 图片是否愿意公开
      isNotPrivate: true,
      inputImg: null,
      isLoading: false,
      // 图片解码后data url
      inputImgDecode: null,
      successUploadDialog: false,
      uploadedImgUrl: '',
      errorMsg: '',
      showErrorMsg: false,
      acceptImgTypes
    }
  },
  methods: {
    onInputImgChange() {
      this.inputImgDecode = null
      const reads = new FileReader()

      reads.readAsDataURL(this.inputImg)

      // eslint-disable-next-line
      const _this = this
      reads.onload = function() {
        _this.inputImgDecode = this.result
      }
    },
    goBack() {
      if (window.history.length <= 1) {
        this.$router.replace('/')
      } else {
        this.$router.back()
      }
    },
    onUploadBtn() {
      if (!this.inputImg || !this.inputImgDecode) {
        return
      }
      this.uploadAlertDialog = true
    },
    // 继续上传
    onContinueUpload() {
      this.successUploadDialog = false
      window.location.reload()
    },
    onGoToMy() {
      this.successUploadDialog = false
      this.$router.push(`/imgu/${this.$route.params.type}/my/0`)
    },
    // 确认开始上传
    async onConfirmUpload() {
      this.uploadAlertDialog = false
      this.isLoading = true
      this.imgUploadPercent = 0
      try {
        // 开始上传
        let ossStsInfo = null
        /* ---上传到OSS--- */
        const typeMime = this.inputImg.type
        const fileSuffix = typeMime.slice(-typeMime.lastIndexOf('/') + 2)
        try {
          ossStsInfo = (await ossSts(fileSuffix, 'a1')).data.data
        } catch (e) {
          throw new Error('获取上传凭证出错')
        }

        let OssPackage = null
        try {
          OssPackage = await import('ali-oss')
        } catch (e) {
          throw new Error('获取上传脚本出错')
        }
        const Oss = OssPackage.default
        const client = new Oss({
          region: 'oss-cn-shanghai',
          bucket: ossStsInfo.ossBucket,
          accessKeyId: ossStsInfo.sts.AccessKeyId,
          accessKeySecret: ossStsInfo.sts.AccessKeySecret,
          stsToken: ossStsInfo.sts.SecurityToken
        })

        // eslint-disable-next-line
        const _this = this
        const ossUploadRes = await client.multipartUpload(
          ossStsInfo.assetPath,
          this.inputImg,
          {
            progress: async (p, checkpoint) => {
              _this.imgUploadPercent = Math.abs(Math.ceil(p * 100) - 2)
            }
          }
        )
        if (ossUploadRes.res.status < 200 || ossUploadRes.res.status > 300) {
          throw new Error('视频上传失败')
        }

        this.uploadedImgUrl = `${ossStsInfo.cdnUrl}${ossStsInfo.assetPath}`

        const doneRes = await doneUploadImg({
          uuid: ossStsInfo.uuid,
          assetPath: ossStsInfo.assetPath,
          classify: '',
          privacy: !this.isNotPrivate,
          atype: asssetNameToId(this.$route.params.type)
        })

        this.successUploadDialog = true
        this.isLoading = false
      } catch (e) {
        this.showErrorMsg = true
        this.errorMsg = `上传出错，${e.message}`
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.img-preview {
  background-color: black;
}
</style>
